import { render, staticRenderFns } from "./Remove-Favourite.vue?vue&type=template&id=f94ebe80&"
import script from "./Remove-Favourite.vue?vue&type=script&lang=js&"
export * from "./Remove-Favourite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports